// Consistent trim/normalize helpers used at the service boundary so the same
// rules apply everywhere. Replaces ad-hoc `.trim()` / `.toLowerCase().trim()`
// calls accumulated during Phases 5A and 5B.
//
// Always normalize at the call site (where data leaves the form) rather than
// inside the service — the displayed value in the form stays exactly what the
// user typed, but the value we write to the DB or send to the auth provider is
// the cleaned-up one.

const toStr = (value) => String(value ?? '');

// Trim leading/trailing whitespace. The default for any user-typed text field.
export function normalizeText(value) {
  return toStr(value).trim();
}

// Trim + lowercase. Use for case-insensitive identifiers like email so
// "JohnDoe@x.com" and "johndoe@x.com" resolve to the same account.
export function normalizeEmail(value) {
  return toStr(value).trim().toLowerCase();
}

// Trim + collapse internal whitespace runs to a single space. Use for
// human-typed fields where double-spaces or stray tabs are unintentional
// (display names, system labels) — not for free-form notes where line breaks
// are intentional.
export function normalizeWhitespace(value) {
  return toStr(value).trim().replace(/\s+/g, ' ');
}
